import authApiHttp from "./authApi";
import baseApiHttp from "./baseApi";

let zkHttp = {
    ...authApiHttp,
    ...baseApiHttp,
};
export default zkHttp;
